import { render, staticRenderFns } from "./MealSchedulePanel.vue?vue&type=template&id=70dd93a9&scoped=true"
import script from "./MealSchedulePanel.vue?vue&type=script&lang=js"
export * from "./MealSchedulePanel.vue?vue&type=script&lang=js"
import style0 from "./MealSchedulePanel.vue?vue&type=style&index=0&id=70dd93a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dd93a9",
  null
  
)

export default component.exports